import { render, staticRenderFns } from "./STextArea.vue?vue&type=template&id=267b962e&"
import script from "./STextArea.vue?vue&type=script&lang=js&"
export * from "./STextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports